   const switchLanguage = async (newLang) => {
        let action = `${window.langCfg.switchUrl}`;
        let nextUrl = window.langCfg[newLang];
        const settings = {
            method: 'POST',
            body: JSON.stringify({
                language: newLang,
            }),
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRFToken': window.csrfToken,
            }
        };
        const response = await fetch(action, settings);
        if (!response.ok) {
            throw Error(response.message);
        } else {
            window.location.href = nextUrl;
        }
    }

    export default switchLanguage;